module.exports = __webpack_public_path__ + "img/bg.29588666.png";